import { useQuery } from '@tanstack/react-query';

import { getUploadList } from 'api/uploads';
import { useCurrentLabId } from 'utils/useCurrentLab';

import { getStudyIngestNotice } from './ingestNotice';

const ACTIVE_INGEST_REFRESH_MS = 15000;
const IDLE_REFRESH_MS = 120000;

// Shared with CaseManifestIngestNotice so both read one cached query instead of firing their own.
export const useStudyIngestStatus = (studyId: string) => {
  const { labId } = useCurrentLabId();
  const { data: uploadList, isLoading } = useQuery({
    queryKey: ['studyUploads', studyId, labId],
    queryFn: () => getUploadList({ studyId, labId }),
    staleTime: 0,
    refetchOnMount: 'always',
    refetchInterval: (data) => (getStudyIngestNotice(data).inProgress > 0 ? ACTIVE_INGEST_REFRESH_MS : IDLE_REFRESH_MS),
  });

  return { uploadList, isLoading };
};
